export class SyncFABService {
  active: boolean = false
}
